(ns frontend.domain.exit-opportunity.actions
  (:require
   [common.localization :as loc]
   [frontend.actions.exit-opportunity :as exit-opportunity-actions]
   [frontend.logging :as logging]
   [frontend.view.modals.confirmation.view :as confirmation]
   [frontend.view.modals.events :as modals]))

(defn resurrect!
  [entity]
  (exit-opportunity-actions/*->resurrect!
   {:exit-opportunity-id (:db/id entity)}
   (fn [_])
   (fn [err]
     (logging/error "Failed to reactivate froppo " err))))

(defn won!
  [{:keys [entity _reset-focus!]}]
  (modals/open-modal!
   confirmation/modal-key
   {:body           [:div.text-center
                     [:p (loc/tr :exit-opportunity-confirm-won)]]
    :confirm-text   (loc/tr :confirm)
    :confirm-icon   ""
    :skip-checkbox? true
    :on-confirm     (fn [_]
                      (exit-opportunity-actions/*->won!
                       {:exit-opportunity-id (:db/id entity)}
                       (fn [_])
                       (fn [err]
                         (logging/error "Failed to set exit oppo as Won " err))))}))
